import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '@views/layout'

// 解决NavigationDuplicated:报错
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

//使用Vue.mixin的方法拦截了路由离开事件，并在该拦截方法中实现了销毁页面缓存的功能。
Vue.mixin({
  beforeRouteLeave: function(to, from, next) {
    //此处判断是如果返回上一层，你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。
    to.meta.rank = to.meta.rank || 1
    if (
      from &&
      from.meta.rank &&
      to.meta.rank &&
      from.meta.rank >= to.meta.rank
    ) {
      if (this.$vnode && this.$vnode.data.keepAlive) {
        if (
          this.$vnode.parent &&
          this.$vnode.parent.componentInstance &&
          this.$vnode.parent.componentInstance.cache
        ) {
          if (this.$vnode.componentOptions) {
            var key =
              this.$vnode.key == null
                ? this.$vnode.componentOptions.Ctor.cid +
                  (this.$vnode.componentOptions.tag
                    ? `::${this.$vnode.componentOptions.tag}`
                    : '')
                : this.$vnode.key
            var cache = this.$vnode.parent.componentInstance.cache
            var keys = this.$vnode.parent.componentInstance.keys
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key)
                if (index > -1) {
                  keys.splice(index, 1)
                }
              }
              delete cache[key]
            }
          }
        }
      }
      this.$destroy()
    }
    next()
  }
})

// 不区分用户角色
export const constantRouterMap = [
  { path: '/demo', component: () => import('@views/demo') },
  { path: '/demo2', component: () => import('@views/demo/my-information') },
  {
    path: '/',
    name: 'index',
    component: Layout,
    meta: { title: '首页' },
    redirect: '/home',
    children: [
      // 首页
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home'),
        meta: { title: '首页', menuLevel: 1, rank: 1 }
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/home/search'),
        meta: {
          title: '搜索',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '搜索',
            disabled: true
          }],
          rank: 1,
        }
      },
      {
        path: '/activity',
        name: 'activity',
        component: () => import('@/views/activity'),
        meta: {
          title: '社会教育',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '社会教育',
            disabled: true
          }],
          rank: 1,
          // keepAlive: true
        }
      },
      {
        path: '/activity/detail',
        name: 'activityDetail',
        component: () => import('@/views/activity/detail'),
        meta: {
          title: '社教详情',
          // breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '社会教育',
            href: '/activity'
          }, {
            text: '详情',
            disabled: true
          }],
          useStore: true,  // 采用状态中的面包屑数据
          // hasLine: true,
          rank: 2,
          keepAlive: false,
        }
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product'),
        meta: {
          title: '文创产品',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '文创产品',
            disabled: true
          }],
          rank: 1,
          // keepAlive: true
        }
      },
      {
        path: '/product/detail',
        name: 'productDetail',
        component: () => import('@/views/product/detail'),
        meta: {
          title: '文创详情',
          // breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '文创产品',
            href: '/product'
          }, {
            text: '详情',
            disabled: true
          }],
          // useStore: true,  // 采用状态中的面包屑数据
          // hasLine: true,
          rank: 2,
          keepAlive: false,
        }
      },
      {
        path: '/exhibition',
        name: 'exhibition',
        component: () => import('@/views/exhibition'),
        meta: {
          title: '陈列展览',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '陈列展览',
            disabled: true
          }],
          rank: 1,
          // keepAlive: true
        }
      },
      {
        path: '/exhibition/detail',
        name: 'exhibitionDetail',
        component: () => import('@/views/exhibition/detail'),
        meta: {
          title: '展览详情',
          // breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '展览',
            href: '/exhibition'
          }, {
            text: '详情',
            disabled: true
          }],
          // useStore: true,  // 采用状态中的面包屑数据
          // hasLine: true,
          rank: 2,
          keepAlive: false,
        }
      },
      {
        path: '/collect',
        name: 'collect',
        component: () => import('@/views/collect'),
        meta: {
          title: '馆藏精品',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '馆藏精品',
            disabled: true
          }],
          rank: 1,
          // keepAlive: true
        }
      },
      {
        path: '/collect/detail',
        name: 'collectDetail',
        component: () => import('@/views/collect/detail'),
        meta: {
          title: '馆藏精品详情',
          // breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '馆藏精品',
            href: '/collect'
          }, {
            text: '详情',
            disabled: true
          }],
          // useStore: true,  // 采用状态中的面包屑数据
          // hasLine: true,
          rank: 2,
          keepAlive: false,
        }
      },
      {
        path: '/video',
        name: 'video',
        component: () => import('@/views/video'),
        meta: {
          title: '视频资源',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '视频资源',
            disabled: true
          }],
          rank: 1,
          // keepAlive: true
        }
      },
      // {
      //   path: '/video/detail',
      //   name: 'videoDetail',
      //   component: () => import('@/views/video/detail'),
      //   meta: {
      //     title: '视频详情',
      //     // breadStyleType: '2',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '视频',
      //       href: '/video'
      //     }, {
      //       text: '详情',
      //       disabled: true
      //     }],
      //     useStore: true,  // 采用状态中的面包屑数据
      //     // hasLine: true,
      //     rank: 2,
      //     keepAlive: false,
      //   }
      // },
    //   {
    //     path: '/visit',
    //     name: 'visit',
    //     component: () => import('@/views/visit'),
    //     meta: {
    //       title: '参观',
    //       breadList: [{
    //         text: '首页',
    //         href: '/home'
    //       }, {
    //         text: '参观',
    //         disabled: true
    //       }],
    //     }
    //   },
    //   {
    //     path: '/culture',
    //     name: 'culture',
    //     component: () => import('@/views/culture'),
    //     meta: {
    //       title: '文化',
    //       breadList: [{
    //         text: '首页',
    //         href: '/home'
    //       }, {
    //         text: '文化',
    //         disabled: true
    //       }],
    //       rank: 1,
    //       keepAlive: false
    //     }
    //   },
    //   {
    //     path: '/culture/detail',
    //     name: 'cultureDetail',
    //     component: () => import('@/views/culture/detail'),
    //     meta: {
    //       title: '详情',
    //       breadList: [{
    //         text: '首页',
    //         href: '/home'
    //       }, {
    //         text: '文化',
    //         href: '/culture'
    //       }, {
    //         text: '详情',
    //         disabled: true
    //       }],
    //       useStore: true,  // 采用状态中的面包屑数据
    //       rank: 2,
    //       keepAlive: false,
    //     }
    //   },
      {
        path: '/service',
        name: 'service',
        component: () => import('@/views/service'),
        meta: {
          title: '服务',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '服务',
            disabled: true
          }],
        }
      },

      {
        path: '/information',
        name: 'information',
        component: () => import('@/views/information'),
        meta: {
          title: '资讯动态',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '资讯动态',
            disabled: true
          }],
          rank: 1,
          keepAlive: false
        }
      },
      {
        path: '/information/detail',
        name: 'informationDetail',
        component: () => import('@/views/information/detail'),
        meta: {
          title: '详情',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '资讯动态',
            href: '/information?pageType=3'
          }, {
            text: '详情',
            disabled: true
          }],
          // useStore: true,  // 采用状态中的面包屑数据
          rank: 2,
          keepAlive: false,
        }
      },

      {
        path: '/notice',
        name: 'notice',
        component: () => import('@/views/notice'),
        meta: {
          title: '通知公告',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '通知公告',
            disabled: true
          }],
          rank: 1,
          keepAlive: false
        }
      },
      {
        path: '/notice/detail',
        name: 'noticeDetail',
        component: () => import('@/views/notice/detail'),
        meta: {
          title: '详情',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '通知公告',
            href: '/notice?pageType=3'
          }, {
            text: '详情',
            disabled: true
          }],
          // useStore: true,  // 采用状态中的面包屑数据
          rank: 2,
          keepAlive: false,
        }
      },

      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about'),
        meta: {
          title: '关于我们',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '关于我们',
            disabled: true
          }],
          rank: 1,
          keepAlive: false
        }
      },
      {
        path: '/about/detail',
        name: 'aboutDetail',
        component: () => import('@/views/about/detail'),
        meta: {
          title: '详情',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '关于我们',
            href: '/about'
          }, {
            text: '详情',
            disabled: true
          }],
          // useStore: true,  // 采用状态中的面包屑数据
          rank: 2,
          keepAlive: false,
        }
      },
    ]
  }
]

// 区分用户角色
export const asyncRouterMap = [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: Layout,
  //   meta: { title: '首页' },
  //   redirect: '/home',
  //   children: [
  //     // 首页
  //     {
  //       path: '/home',
  //       name: 'home',
  //       component: () => import('@/views/home'),
  //       meta: { title: '首页', menuLevel: 1, rank: 1 }
  //     }
  //   ]
  // }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
